import React from "react";

interface BoxIconProps {
  size?: string;
  color?: string;
  className?: string;
}

const BoxIcon: React.FC<BoxIconProps> = ({ 
  size = "24px", 
  color = "currentColor", 
  className = "" 
}) => {
  return (
    <svg 
      height={size} 
      width={size} 
      viewBox="0 0 21 21" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g 
        fill="none" 
        fillRule="evenodd" 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        transform="translate(3 3)"
      >
        <path d="m8.49227788 1.06701593 5.00000002 2.85714286c.62315.35608571 1.0077221 1.01877259 1.0077221 1.73648628v4.67870983c0 .7177137-.3845721 1.3804006-1.0077221 1.7364863l-5.00000002 2.8571429c-.61486534.3513516-1.36969042.3513516-1.98455576 0l-5-2.8571429c-.62314999-.3560857-1.00772212-1.0187726-1.00772212-1.7364863v-4.67870983c0-.71771369.38457213-1.38040057 1.00772212-1.73648628l5-2.85714286c.61486534-.35135162 1.36969042-.35135162 1.98455576 0z" />
        <path d="m11 6.5-7-4" />
        <path d="m1 5 5.55180035 2.98943096c.59195265.31874373 1.30444665.31874373 1.8963993 0l5.55180035-2.98943096" />
        <path d="m7.5 8.5v6.5" />
      </g>
    </svg>
  );
};

export default BoxIcon;
